import * as React from 'react'
import type { PaymentRecoveryModel } from './types'

export interface PaymentRecoveryStatusDialogProps {
  model: PaymentRecoveryModel | null
  onClose: () => void
  locale?: string
  zIndex?: number
  overlayZIndex?: number
  portalContainer?: HTMLElement | null
}

const PaymentRecoveryStatusDialogBody = React.lazy(() =>
  import('./payment-recovery-status-dialog-body').then(module => ({
    default: module.PaymentRecoveryStatusDialogBody,
  })),
)

export function PaymentRecoveryStatusDialog(props: PaymentRecoveryStatusDialogProps) {
  return (
    <React.Suspense fallback={null}>
      {props.model ? <PaymentRecoveryStatusDialogBody {...props} /> : null}
    </React.Suspense>
  )
}
